import { FormProvider } from "react-hook-form";
import { Input, Listbox, Textarea } from "@/components/ui/form";
import { Button } from "@/components/ui/button";

export const ContactForm = ({ methods, onSubmit, isPending }) => {
    return (
        <FormProvider {...methods}>
            <form
                onSubmit={methods.handleSubmit(onSubmit)}
                className="grid gap-4"
            >
                <div>
                    <Input
                        type="text"
                        name="contactName"
                        label="YOUR NAME"
                        placeholder="Jane Smith"
                    />
                </div>
                <div>
                    <Input
                        type="text"
                        name="contactEmail"
                        label="YOUR EMAIL"
                        placeholder="jane@example.com"
                    />
                </div>
                <div>
                    <Listbox
                        name="contactReason"
                        label="SUBJECT"
                        placeholder="Please select an option"
                    >
                        <option value="Booking question">
                            Booking question
                        </option>
                        <option value="Account help">Account help</option>
                        <option value="Clinician support">
                            Clinician support
                        </option>
                        <option value="Feedback">Feedback</option>
                        <option value="Something else">Something else</option>
                    </Listbox>
                </div>
                <div>
                    <Textarea
                        name="contactMessage"
                        label="MESSAGE"
                        placeholder="Tell us what you need help with..."
                    ></Textarea>
                </div>
                <Button
                    type="submit"
                    variant="primary"
                    className="mt-2 w-full"
                    disabled={isPending}
                >
                    {isPending ? "Sending" : "Send message"}
                </Button>
            </form>
        </FormProvider>
    );
};
